// React
import React from 'react';
// External libs
import classNames from 'classnames';
// Assets
import icon from '../../../assets/images/restaurant.png';
// Styles
import useStyles from './RestaurantIcon.styles';

const RestaurantIcon = ({ className }) => {
  const componentClasses = useStyles();
  return (
    <img
      className={classNames(componentClasses.root, className)}
      alt='Restaurant icon'
      src={icon}
    />
  );
};

RestaurantIcon.defaultProps = {};

export default RestaurantIcon;
